import { APIConfigModulesName, FEConfigModulesName } from "./constants";
import { SupportConfig, SupportConfigValue } from "./types";

export const generateSupportConfigs = (appConfigs: Array<SupportConfig>) => {
    const appConfig: any = {};

    appConfigs.forEach((config: SupportConfig) => {
        const configValues = config.config_values;
        const configType = config.module;

        configValues?.forEach((configValue: SupportConfigValue) => {
            const serverConfigKey = configValue.config_name;
            let dataObj;

            if (
                !(
                    configValue.config_value === undefined ||
                    configValue.config_value === ""
                ) &&
                configValue.configuration_type !== "TEXT"
            ) {
                dataObj = {
                    [serverConfigKey]: JSON.parse(configValue.config_value),
                };
            } else {
                dataObj = {
                    [serverConfigKey]: configValue.config_value,
                };
            }

            switch (configType) {
                case APIConfigModulesName.practiceSupport:
                    appConfig[FEConfigModulesName.practiceSupport] = {
                        ...appConfig[FEConfigModulesName.practiceSupport],
                        ...dataObj,
                    };
                    break;

                case APIConfigModulesName.technicalSupport:
                    appConfig[FEConfigModulesName.technicalSupport] = {
                        ...appConfig[FEConfigModulesName.technicalSupport],
                        ...dataObj,
                    };
                    break;

                case APIConfigModulesName.questionnaireService:
                    appConfig[FEConfigModulesName.questionnaireService] = {
                        ...appConfig[FEConfigModulesName.questionnaireService],
                        ...dataObj,
                    };
                    break;
            }
        });
    });

    return appConfig;
};
